<template>
  <div>
    <div class="portlet">
      <div class="portlet-head">
        <h3><i class="fas fa-briefcase"></i> Ewidencja czasu pracy</h3>
        <b-button variant="outline-primary" class="mr-2" @click="exportPdf" v-if="hasAccess('schedulesModify')"><i class="fas fa-file-export"/>&nbsp;&nbsp;Eksportuj do PDF</b-button>
      </div>
   <div class="portlet-body">
      <div>
                  <div class="schedule">
                    <div class="schedule-operator">
                      <div class="schedule-employees" v-if="hasAccess('schedulesModify')">
                        <multiselect
                            v-model="selected"
                            placeholder="Wybierz pracownika"
                            label="fullname"
                            :options="names"
                            :multiple="false"
                            style="min-width: 300px;"
                            @input="getWorkSchedule"
                        ></multiselect>
                      </div>
                      <div class="schedule-employees" v-else>Użytkownik: <b> {{this.singleUser.firstname}} {{this.singleUser.lastname}}</b></div>
                      <div class="schedule-date">
                        <div>
                          <b-button variant="outline-primary" id="back" @click="monthMove(`backward`)"><i class="fas fa-angle-left"/></b-button>
                            <div>
                              <label>{{this.currentYear}} {{getMonthName}}</label>

                            </div>
                          <b-button variant="outline-primary" id="forward" @click="monthMove(`forward`)"><i class="fas fa-angle-right"/></b-button>
                        </div>
                        <div class="schedule-reset">
                        <b-button variant="outline-primary" @click="resetDate">Reset</b-button>
                        </div>
                      </div>
                    </div>

                  </div>

      </div>

            <b-table striped hover
                     class="table table-list table-mobile"
                     :items="timetables"
                     :fields="fields"
                     :busy.sync="isBusy"
                     stacked="lg"
                     show-empty
                     empty-text="Brak wybranej osoby">
              <template v-slot:table-busy>
                <TableSpiner />
              </template>
              <template v-slot:empty="{ emptyText }">
                <div class="empty">
                  <i class="fas fa-users empty-state"></i>
                  <span class="empty-search">{{ emptyText }}</span>
                </div>
              </template>

              <template v-slot:cell(day)="data">
                {{currentYear}}-{{String(currentMonth+1).padStart(2, "0")}}-{{ String(data.item.day).padStart(2, "0") }}
              </template>
              <template v-slot:cell(places)="data">
                <div v-if="editedItem.day == data.item.day">
                  <b-form-input v-model="editedItem.place" placeholder="Miejsce"></b-form-input>
                </div>
                <div v-else>{{data.item.place? data.item.place : '---'}}</div>
              </template>
              <template v-slot:cell(hours)="data">
                <div v-if="editedItem.day == data.item.day">
                  <b-form-input v-model="editedItem.hours" placeholder="Godziny"></b-form-input>
                </div>
                <div v-else>{{data.item.hours? data.item.hours.toFixed(2) : '---'}}</div>

              </template>
              <template v-slot:cell(notices)="data">
                <div v-if="editedItem.day == data.item.day">
                  <b-form-input v-model="editedItem.notice" placeholder="Uwagi"></b-form-input>
                </div>
                <div v-else>{{data.item.notice? data.item.notice : '---'}}</div>
              </template>

              <template v-slot:cell(actions)="data" v-if="hasAccess('schedulesModify')">
                <div v-if="editedItem === data.item">
                  <b-button variant="outline-danger" @click="cancelRecord(data)" class="mr-4"><i class="fas fa-times"/></b-button>
                  <b-button variant="outline-success" @click="addRecord(data.item)">Dodaj</b-button>
                </div>
                <div v-else>
                  <b-button variant="outline-primary" @click="editRecord(data)"><i class="fas fa-pencil-alt"/></b-button>
                </div>
              </template>

            </b-table>
          <div  class="schedule-sum" v-if="this.selected.id !== undefined"> Suma godzin łącznie: <b class="hours"> {{sumHours.toFixed(2)}} godzin</b></div>
      </div>

    </div>
  </div>
</template>

<script>

import {getDate} from "@/services/helpers";
import ScheduleService from "@/services/schedule.service";
import {mapGetters} from "vuex";
import EmployeesService from "@/services/employees.service";
import TableSpiner from "../components/TableSpiner";



export default {
  name: "TheWorkSchedule",
  components: {TableSpiner },


  data() {
    return {
      monthStart: null,
      monthEnd: null,
      tableData: [],
      search: "",
      items: null,
      selected: "",
      isBusy: false,
      getDays: '',
      currentMonth: 0,
      currentYear: 0,
      editedItem: false,
      saveContext: {},
      scheduleData: [],
      scheduleMonth: [],
      names: [],
      singleUser: "",

      timetables: [],
      fields: [
        { key: "day", label: "Dzień" },
        { key: "hours", label: "Godziny" },
        { key: "places", label: "Miejsce" },
        { key: "notices", label: "Uwagi" },
        { key: "actions", label: "Akcje", class:"text-right" },
      ],
      hideContext: true,


    }
  },

  computed: {
    ...mapGetters("user", ["getMyId", "getRole", "hasAccess"]),
    ...mapGetters("app", ["optionsStatus", "availableEmployees"]),



    getMonthName(){
      switch (this.currentMonth) {
        case 0: return 'Styczeń'
        case 1: return 'Luty'
        case 2: return 'Marzec'
        case 3: return 'Kwiecień'
        case 4: return 'Maj'
        case 5: return 'Czerwiec'
        case 6: return 'Lipiec'
        case 7: return 'Sierpień'
        case 8: return 'Wrzesień'
        case 9: return 'Październik'
        case 10: return 'Listopad'
        case 11: return 'Grudzień'
        default: return 'Nieznany'
      }
    },
    sumHours(){

      let expectedSum = 0;
      for (let i = 0; i < this.timetables.length; i++) {
        let hours = this.timetables[i].hours
        if (hours == null) {continue}
        expectedSum += hours;
      }
      return expectedSum
    },


  },

  mounted() {
    this.multiSelectUser();

    this.setStartMonth()
    this.setStartYear();
    this.searchedMonth();
    this.fullMonthSet();
    this.getEmployees();
    this.getWorkSchedule();
    this.fillTimetables();

  },
  watch: {
    editedItem: {
      handler: function (val){
        if (val.hours) {
          val.hours = parseFloat(val.hours)
        }
      },
      deep: true
    }
  },

  methods: {
    multiSelectUser(){
      if (this.hasAccess('schedulesModify') === true){
        return
      } else {
        this.selected = {id: this.getMyId}
      }
    },

    getDate,

    searchedMonth(month, year){
      return new Date(year, month, 0).getDate();
    },

    setStartMonth() {
      this.currentMonth= getDate()[1]
    },
    setStartYear() {
      this.currentYear = getDate()[0]
    },

    monthMove(direction){
      this.editedItem = false
      if(direction == `forward`) {
        this.currentMonth += 1
        if (this.currentMonth > 11) {
          this.currentYear +=1
          this.currentMonth = 0
        }
      }
      else if (direction == `backward`) {
        this.currentMonth -= 1
        if (this.currentMonth < 0) {
          this.currentYear -=1
          this.currentMonth = 11
        }
      }

      this.fullMonthSet()
      this.getWorkSchedule()
      this.fillTimetables()

    },

    fillTimetables () {
      if(this.selected == null || this.selected.id == null ){
        return
      } else {
        const daysInMonth = this.searchedMonth(this.currentMonth+1,this.currentYear)
        if(this.scheduleData === undefined){
          return [];
        } else {

        this.timetables = [];
        for (let i = 0; i < daysInMonth; i++) {
          const day = i + 1 ;
          let place = null;
          let hours = null;
          let notice = null;
          let id = null;

          const activeDataIndex = this.scheduleData.findIndex(x => new Date(x.date.slice(0, -1)).getDate() == day)

          if (activeDataIndex >= 0 ) {
            place = this.scheduleData[activeDataIndex].place
            hours = this.scheduleData[activeDataIndex].hours
            notice = this.scheduleData[activeDataIndex].notice
            id = this.scheduleData[activeDataIndex].id
          }
          this.timetables.push({day, hours, place, notice, id})
         }

        }
      }

    },
    addRecord (data){

      const index = this.timetables.findIndex(item => item.day == data.day)

      this.timetables[index] = data

      if (this.timetables[index].hours == "" && this.timetables[index].place == "" && this.timetables[index].notice == "") {
        if(this.hasAccess('schedulesDelete') === true)
        {
        ScheduleService.delete(this.timetables[index].id)
            .then(() => {

            })
            .finally(() => {
              this.isBusy = false;
              this.editedItem = false

            });
        }

      } else if (this.saveContext.item.hours === null && this.saveContext.item.place === null && this.saveContext.item.notice === null) {
        if(this.hasAccess('schedulesModify') === true){

        this.editedItem.user_id = this.selected.id,
        this.editedItem.date = `${this.currentYear}-${String(this.currentMonth+1).padStart(2, "0")}-${ String(this.timetables[index].day).padStart(2, "0") }`

        ScheduleService.create(this.editedItem)
            .then((response) => {
              this.timetables[index].id = response.id
              this.editedItem = false

            })
            .finally(() => {
              this.isBusy = false;

            });
        }

      } else {
        if(this.hasAccess('schedulesModify') === true){

        this.isBusy = true;

        ScheduleService.update(this.timetables[index].id, this.editedItem)
            .then((response) => {
              this.timetables[index].id = response.id
              this.editedItem = false

            })
            .finally(() => {
              this.isBusy = false;
              // this.editedItem = false
            });
        }
      }

    },
    editRecord (data){
      this.editedItem = data.item
      this.saveContext = JSON.parse(JSON.stringify(data))
      if (this.saveContext.item.hours == "" && this.saveContext.item.place == "" && this.saveContext.item.notice == "")
      {
        this.saveContext.item.hours = null
        this.saveContext.item.place = null
        this.saveContext.item.notice = null
      }
    },
    cancelRecord (data) {

      this.editedItem = false
      data.item.hours = this.saveContext.item.hours
      data.item.place = this.saveContext.item.place
      data.item.notice = this.saveContext.item.notice

    },

    async getWorkSchedule() {

      if(this.selected == null || this.selected.id == undefined || this.selected.id == null){
        this.selected = []
        this.timetables = []

      } else {

      this.isBusy = true;
      await ScheduleService.getByDate(this.selected.id, this.monthStart, this.monthEnd)
          .then((response) => {
            this.scheduleData = response
          })
          .finally(() => {
            this.isBusy = false;
          });
      }
      this.fillTimetables()
    },

    getEmployees() {
      if (this.hasAccess('schedulesModify') === false){
        return EmployeesService.search(this.search.trim())
            .then((response) => {
              this.singleUser = response.find(x => x.id === this.selected.id)
            })
            .catch(() => {
            });

      } else {

      return EmployeesService.search(this.search.trim())
          .then((response) => {
            this.names = response.map(item => {
              item.fullname = `${item.firstname} ${item.lastname}`
              return item
            });
          })
          .catch(() => {
          });
      }
    },

    pushDay () {
      this.hideContext = false;
    },

    resetDate (){
      this.editedItem = false
      this.setStartMonth();
      this.setStartYear();
      this.fillTimetables();
      this.fullMonthSet()
    },
    fullMonthSet(){
      let daysInMonth = this.searchedMonth(this.currentMonth+1,this.currentYear)
      this.monthStart = `${this.currentYear}-${String(this.currentMonth+1).padStart(2, "0")}-01`
      this.monthEnd = `${this.currentYear}-${String(this.currentMonth+1).padStart(2, "0")}-${daysInMonth}`
    },


    exportPdf() {
      this.exporting = true;
      ScheduleService.download(this.selected.id, this.monthStart, this.monthEnd)
          .then((response) => {
            let blob = new Blob([response.data], { type: "application/pdf" }),
                url = window.URL.createObjectURL(blob);
            window.open(url);
          })
          .finally(() => {
            this.exporting = false;
          });
    },


  }
}
</script>
